import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("edutime_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setAuth = (token, user) => {
  if (token) localStorage.setItem("edutime_token", token);
  if (user) localStorage.setItem("edutime_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("edutime_token");
  localStorage.removeItem("edutime_user");
};

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("edutime_user") || "null"); }
  catch { return null; }
};

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
